import {ApolloClient, InMemoryCache, createHttpLink} from '@apollo/client';

const httpLink = createHttpLink({uri: 'https://api.studio.thegraph.com/query/88204/aument-graph-dev/version/latest'});
 
export const client = new ApolloClient({link: httpLink, cache: new InMemoryCache()});